import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ENVIRONMENT } from '@ninety/mobile/platform/environments';

import { AssessmentDefinitionsResponse } from '../models/assessment-definitions-response.model';
import { CompanyAssessmentListItemResponse } from '../models/company-assessment-list-item-response.model';
import { CreateCompanyAssessmentRequest } from '../models/create-company-assessment-request.model';

@Injectable({ providedIn: 'root' })
export class SharedAssessmentApiService {
  private readonly http = inject(HttpClient);
  private readonly environment = inject(ENVIRONMENT);

  private readonly apiUrl = this.environment.origin.monolith + '/assessments';
  private readonly COMPANY_ASSESSMENTS_API_URL = `${this.apiUrl}/company-assessments`;

  getAssessmentDefinitions(): Observable<AssessmentDefinitionsResponse[]> {
    return this.http.get<AssessmentDefinitionsResponse[]>(this.apiUrl);
  }

  createCompanyAssessment(
    companyAssessment: CreateCompanyAssessmentRequest
  ): Observable<CompanyAssessmentListItemResponse> {
    return this.http.post<CompanyAssessmentListItemResponse>(`${this.COMPANY_ASSESSMENTS_API_URL}`, companyAssessment);
  }
}
